import { useRuntimeConfig } from '#imports';
import { socialImageSrc } from '~/utils/social-image-proxy';

/**
 * cas-853b: returns `src(url)` for an <img>, <q-img> or poster that may be
 * handed a raw Instagram/Facebook, TikTok or YouTube CDN URL. Those hosts
 * block cross-origin loads (Instagram sends CORP same-origin), so they are
 * rewritten to the public proxy; every other URL, and null, passes through.
 */
export function useSocialImageSrc() {
  const apiBase = useRuntimeConfig().public.apiBase as string | undefined;
  return (url: string | null | undefined): string | undefined =>
    url ? socialImageSrc(url, apiBase) : undefined;
}
